// removed by extract-text-webpack-plugin
module.exports = {"Step5":"Step5","fadeInUp":"fadeInUp","Title":"Title","OtpAuthen":"OtpAuthen","ProgressBar":"ProgressBar","OtpTitle":"OtpTitle","OtpInput":"OtpInput","Timer":"Timer","ResendText":"ResendText","Resend":"Resend","Done":"Done","Step5Mobile":"Step5Mobile","Successfully":"Successfully"};


//////////////////
// WEBPACK FOOTER
// ./src/screens/KisEkyc/Step5/style.scss
// module id = 2320
// module chunks = 10